module.exports = __webpack_public_path__ + "media/images/top/qa/ogp-73e5c5ba5cff16ea81ec428c631b2ba4.png";